module.exports = __webpack_public_path__ + "img/ma220.26a1479c.png";